import React from 'react';

const DiningOverview = ({ language }) => {
  return (
    <section className="py-5">
      <div className="container">
        <h1 className="display-4 fw-bold text-black text-center">
          {language === 'am' ? 'ብሉ ኔስት ሆቴል ሬስቶራንት' : 'Blue Nest Hotel Restaurant'}
        </h1>
        <p className="lead mt-2 text-center">
          {language === 'am' 
            ? 'ባህላዊ እና ዓለም አቀፍ ምግቦች በጥራት እና በአዲስ ሁኔታ' 
            : 'Traditional and international cuisine with quality and freshness'}
        </p>

        <h2 className="fw-bold mb-4">
          {language === 'en' ? 'Overview' : 'አጠቃላይ እይታ'}
        </h2>
        
        <p>
          {language === 'am'
            ? 'የብሉ ኔስት ሆቴል ሬስቶራንት በሰለጠኑ ሾፎች የተዘጋጁ የኢትዮጵያዊና ዓለም አቀፍ ምግቦች እናቀርባለን። ምቹ እና ንፁህ አካባቢ ውስጥ ለቤተሰብ እና ለንግድ ስብሰባዎች ተስማሚ ነው።'
            : "Blue Nest Hotel's Restaurant offers expertly prepared Ethiopian and international cuisine. Our comfortable and clean environment is perfect for family dining and business meetings."}
        </p>

        <p>
          {language === 'am'
            ? 'በሬስቶራንታችን የሚገኙ፡ የተለያዩ የኢትዮጵያ ባህላዊ ምግቦች፣ ዓለም አቀፍ ምግቦች፣ ትኩስ ጁስ እና መጠጦች፣ ምቹ የመመገቢያ አካባቢ፣ ባለሙያ አገልግሎት።'
            : 'Our restaurant features: Various traditional Ethiopian dishes, international cuisine, fresh juices and beverages, comfortable dining atmosphere, and professional service.'}
        </p>

        <h4 className="mt-4">
          {language === 'am' ? 'ዋና ነጥቦች' : 'Highlights'}
        </h4>

        <div className="table-responsive">
          <table className="table table-bordered mt-3">
            <thead className="table-light">
              <tr>
                <th>{language === 'am' ? 'አገልግሎት' : 'Service'}</th>
                <th>{language === 'am' ? 'መግለጫ' : 'Description'}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{language === 'am' ? 'የኢትዮጵያ ምግቦች' : 'Ethiopian Cuisine'}</td>
                <td>{language === 'am' ? 'ባህላዊ እንጀራ እና ወጦች' : 'Traditional injera and stews'}</td>
              </tr>
              <tr>
                <td>{language === 'am' ? 'ዓለም አቀፍ ምግቦች' : 'International Dishes'}</td>
                <td>{language === 'am' ? 'ፓስታ፣ ሳላድ እና ሌሎች' : 'Pasta, salads and more'}</td>
              </tr>
              <tr>
                <td>{language === 'am' ? 'መጠጦች' : 'Beverages'}</td>
                <td>{language === 'am' ? 'ትኩስ ጁስ፣ ቡና እና ሌሎች' : 'Fresh juices, coffee and more'}</td>
              </tr>
              <tr>
                <td>{language === 'am' ? 'አገልግሎት ሰዓት' : 'Service Hours'}</td>
                <td>{language === 'am' ? 'ከጠዋት 6:00 እስከ ምሽት 11:00' : '6:00 AM to 11:00 PM'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default DiningOverview;
